import { useState } from "react"
import { useDebounce } from "use-debounce"

import { useGetTicketingFieldOptions } from "@/api/useJira"
import { Select, Spin } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./TicketField.module.scss"

import type { TicketOptionsSelectProps } from "./TicketField.types"

const SEARCH_DEBOUNCE_MS = 500
const OPTIONS_STALE_TIME = 30000

export const TicketOptionsSelect = (props: TicketOptionsSelectProps) => {
  const { system, projectId, fieldKey, multiple, disabled, value, onChange } =
    props
  const [search, setSearch] = useState("")
  const [q] = useDebounce(search, SEARCH_DEBOUNCE_MS)
  const { t } = useTranslation("translation", { keyPrefix: "ticketModal" })
  const { response, isLoading } = useGetTicketingFieldOptions(
    system,
    { projectId, fieldKey, q: q || undefined },
    { enabled: !!projectId, staleTime: OPTIONS_STALE_TIME }
  )

  return (
    <Select
      showSearch
      allowClear
      mode={multiple ? "multiple" : undefined}
      disabled={disabled}
      value={value}
      filterOption={false}
      loading={isLoading}
      options={response?.data || []}
      onSearch={setSearch}
      onChange={(next: string | string[]) => onChange?.(next)}
      notFoundContent={
        isLoading ? (
          <Spin size="small" className={styles.optionsLoader} />
        ) : (
          t("noResults")
        )
      }
    />
  )
}
